<script>
    import Nav from './Nav.svelte'
</script>

<main class="container">
    <Nav/>
    <h1>Hello and welcome!</h1>
    <p>Please register or log in to participate :)</p>
</main>
